export default __webpack_public_path__ + "static/media/notification1.ef6fd82d.mp3";